<template>
  <div>
    <div class="top">
      <div class="logo">
        <div class="logo-left">
          <img src="@/assets/png/home/logo.png" alt="" />
        </div>
        <div class="logo-right">
          <p style="font-size: 30px; font-weight: bold">
            {{ title }}
          </p>
          <p style="font-size: 20px">www.zhzqw.cn</p>
        </div>
      </div>
      <div class="tab">
        <div class="box active">首页</div>
        <div class="box" @click="noticeClick">通知</div>
        <div class="box" @click="enterpriseClick">企业</div>
        <div class="box" @click="genealogyClick">族谱</div>
        <div class="box" @click="ancestryClick">家谱树</div>
      </div>
    </div>
    <div class="content">
      <div class="con">
        <div class="bigbox">
          <div class="banner">
            <el-carousel :autoplay="true" indicator-position="none" arrow="hover" style="width: 100%; height: 350px">
              <el-carousel-item v-for="(item, index) in slicedArrayList" :key="index"
                style="width: 100%; height: 350px" @click.native="familyDetails(item, '3')">
                <div class="picture" :style="{
                  'background-image': `url(${item.coverImageUrl})`,
                }">
                  <div style="
                      position: absolute;
                      bottom: 0;
                      width: 100%;
                      padding: 10px;
                    ">
                    {{ item.title }}
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="new">
            <div style="position: relative; display: flex">
              <img src="@/assets/png/bwh/windows.png" alt="" />
              <p class="a">通知</p>
              <p class="notice-title" @click="familyDetails(noticeListsFirst,'1')">
                {{ noticeListsFirst.title }}
              </p>
            </div>
            <div class="new-con">
              <div style="display: flex">
                <div class="new-con-text1" v-html="noticeListsFirst.articleText">
                </div>
                <div>...</div>
              </div>
              <div style="width: 100%; margin-top: 70px">
                <div class="new-con-text2" v-for="(item, index) in noticeLists" :key="index">
                  <p class="notice-item-title" @click="familyDetails(item,'1')">
                    {{ item.title.slice(0, 20) }}
                  </p>
                  <p>{{ (item.createTime || '').slice(0, 10) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="big-box">
          <div class="nav">
            <div class="nav-top">
              <p>组织</p>
            </div>
            <div class="nav-con con1">
              <template v-for="(item, index) in organizationList">
                <div class="org-row" :key="index" v-if="item.members.length > 0">
                  <div class="org-label">{{ item.orgName }}:</div>
                  <div class="org-names">
                    <span v-for="(it, idx) in item.members.slice(0, 4)" :key="idx">
                      {{ it.familyName }}{{ it.name }}&nbsp;&nbsp;
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="nav">
            <div class="nav-top">
              <p>企业</p>
              <p style="cursor: pointer" @click="moreClick">+更多</p>
            </div>
            <div class="nav-con con2">
              <div class="content2" v-for="item in familyFirmList" :key="item.id" style="cursor: pointer"
                @click="enterpriseDetails(item)">
                <img :src="item.coverImageUrl" alt="" />
                <div style="height: 44px">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="nav">
            <div class="nav-top">
              <p>宗亲分布</p>
            </div>
            <div class="nav-con con3">
              <div class="content3">
                <p>家族总人数:</p>
                <p style="color: #bf1c28">{{ patrilinealList.totalNum }}</p>
              </div>
              <div class="content3">
                <p>已过世人数:</p>
                <p style="color: #333333">{{ patrilinealList.deathNum }}</p>
              </div>
              <div class="content3">
                <p>在世人数:</p>
                <p style="color: #bf1c28">{{ patrilinealList.liveNum }}</p>
              </div>
              <div class="content3">
                <p>男性:</p>
                <p style="color: #bf1c28">
                  {{ patrilinealList.manNum }}
                </p>
              </div>
              <div class="content3">
                <p>女性:</p>
                <p style="color: #bf1c28">
                  {{ patrilinealList.womanNum }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="e">
        <div class="left2">
          <img src="@/assets/png/home/logo.png" alt="" />
        </div>
        <div class="right2">
          <p>版权所有:&nbsp;&nbsp;安徽图腾传承文化有限公司</p>
          <div style="display: flex">
            <p>客服电话:&nbsp;&nbsp;18963782919</p>
            <p style="margin-left: 20px">
              企业邮箱:&nbsp;&nbsp;zhzqwvip@163.com
            </p>
          </div>
          <div style="display: flex">
            <p>备案号:&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">皖ICP备1833721395-1号</a></p>
            <p style="margin-left: 20px">
              公安备案:&nbsp;&nbsp;皖公网安备 34019202000232号
            </p>
            <a href="https://client.zqyp.net/" target="_blank" style="margin-left: 20px">编委会管理中心</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      patrilinealList: {},
      familyTreeId: "",
      name: "",
      slicedArrayList: [],
      familyFirmList: [],
      organizationList: [],
      noticeLists: [],
      noticeListsFirst: [],
    };
  },

  watch: {
    "$route.query": {
      immediate: true,
      handler(val, oldval) {
        console.log(val, oldval, "val, oldval");
        if (val.name != undefined) {
          localStorage.setItem(
            "val",
            JSON.parse(this.$Base64.decode(val.name))
          );
        }
        if (val.familyTreeId != undefined) {
          localStorage.setItem(
            "familyTreeId",
            JSON.parse(this.$Base64.decode(val.familyTreeId))
          );
        }

        var params = new URLSearchParams(window.location.search);
        this.familyTreeId = params.get("familyTreeId");
        this.name = params.get("name");

        this.title = JSON.parse(this.$Base64.decode(params.get("name")));
      },
    },
  },

  created() {
    this.getSlicedArray();
    this.getNotice();
    this.getOrganization();
    this.getFamilyFirm();
    this.getPatrilineal();
  },

  methods: {
    noticeClick() {
      this.$router.push({
        path: "./ancestorsdetalis",
        query: {
          familyTreeId: this.familyTreeId,
          name: this.name,
        },
      });
    },
    enterpriseClick() {
      this.$router.push({
        path: "./enterprise",
        query: {
          familyTreeId: this.familyTreeId,
          name: this.name,
        },
      });
    },
    genealogyClick() {
      this.$router.push({
        path: "./genealogys",
        query: {
          familyTreeId: this.familyTreeId,
          name: this.name,
        },
      });
    },

    ancestryClick() {
      this.$router.push({
        path: "./tree",
        query: {
          familyTreeId: this.familyTreeId,
          name: this.name,
        },
      });
    },
    moreClick() {
      this.$router.push({
        path: "./enterprise",
        query: {
          familyTreeId: this.familyTreeId,
          name: this.name,
        },
      });
    },

    enterpriseDetails(item) {
      this.$router.push({
        path: "./notice",
        query: {
          familyTreeId: this.familyTreeId,
          name: this.name,
          id: item.id,
          selectedItem: "2",
        },
      });
    },

    familyDetails(item, index) {
      console.log('item',item);
      
      this.$router.push({
        path: "./notice",
        query: {
          familyTreeId: this.familyTreeId,
          name: this.name,
          id: item.id,
          selectedItem: index,
        },
      });
    },

    async getNotice() {
      let res1 = await this.$api.getCommitteeNoticeList(localStorage.getItem("familyTreeId"), 1, 5);
      console.log('已解决 通知栏=>', res1.data.records);
      if (res1.data.records.length >= 1) {
        this.noticeListsFirst = res1.data.records[0];
        this.noticeListsFirst.articleText =
          this.noticeListsFirst.content.replace(/<img[^>]*>/gi, "");
        this.noticeListsFirst.articleText =
          this.noticeListsFirst.content.replace(/<p>&nbsp;<\/p>/gi, "");
        this.noticeLists = res1.data.records.slice(1, 5);
      }
    },


    async getOrganization() {
      let res = await this.$api.getCommitteeManagerList(localStorage.getItem("familyTreeId"))
      console.log('已解决  编委会管理人员信息=>', res.data);
      this.organizationList = res.data;
    },

    async getFamilyFirm() {
      let res1 = await this.$api.getFamilyTreeCompanyList(localStorage.getItem("familyTreeId"), 1, 4)
      console.log('已解决  家族企业=>',res1.data.records);
      this.familyFirmList = res1.data.records;
    },

    async getPatrilineal() {
      let res1 = await this.$api.getFamilyTreeDistributionList(localStorage.getItem("familyTreeId"))
      console.log('已解决  宗亲分布=>', res1.data);
      this.patrilinealList = res1.data;
    },

    async getSlicedArray() {
      let res1 = await this.$api.getCommitteeCarouselList(localStorage.getItem("familyTreeId"))
      console.log('已解决 轮播图=>', res1.data.records);
      this.slicedArrayList = res1.data.records;
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 820px;
  display: flex;
  justify-content: center;
}

.con {
  width: 70%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.bigbox {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: space-between;
}

.big-box {
  width: 100%;
  height: 377px;
  display: flex;
  justify-content: space-between;
}

.banner {
  width: 44%;
  height: 100%;
}

.new {
  width: 54%;
  height: 100%;
  background-image: linear-gradient(0deg, #ffffff 0%, #faf7d4 80%, #f4eea9 98%);
}

.a {
  position: absolute;
  top: 28px;
  left: 27px;
  color: #ffffff;
  font-size: 17px;
  transform: rotate(-45deg);
}

/* --- 关键修改1：通知标题超出省略 --- */
.notice-title {
  position: absolute;
  top: 66px;
  left: 80px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  z-index: 99999;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* --- 关键修改2：通知列表标题超出省略 --- */
.new-con-text2 .notice-item-title {
  font-size: 18px;
  line-height: 36px;
  margin-bottom: 10px;
  color: #333333;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.banner>img {
  width: 100%;
  height: 100%;
}

.banner .picture {
  width: 100.2%;
  height: 350px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.banner .picture div {
  color: #fff;
  background-color: #000;
  opacity: 0.6;
}

.new-con {
  width: 100%;
  height: calc(100% - 100px);
  padding: 0px 43px 29px 23px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.new-con-text1 {
  word-wrap: break-word;
  height: 27px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  text-indent: 2em;
  line-height: 27px;
  color: #333333;
  /* 新增：单行省略 */
  white-space: nowrap;
}

.new-con-text2 {
  font-size: 18px;
  line-height: 36px;
  margin-bottom: 10px;
  color: #333333;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.nav {
  width: 32%;
  background-color: #ffffff;
  height: 100%;
}

.nav-top {
  width: 100%;
  height: 40px;
  color: #ffffff;
  background-image: linear-gradient(90deg, #c2252d 0%, #fdc300 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 23px;
  padding-right: 26px;
  box-sizing: border-box;
}

.nav-con {
  width: 100%;
  height: calc(100% - 40px);
  padding: 20px;
  box-sizing: border-box;
}

.con1 {
  font-size: 16px;
}

.con1>p {
  margin-top: 10%;
  line-height: 30px;
}

.org-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: #333333;
  line-height: 48px;
  /* --- 关键修改3：组织行不换行，超出省略 --- */
  flex-wrap: nowrap;
  overflow: hidden;
}

.org-row:first-child {
  margin-top: 0;
}

.org-label {
  flex-shrink: 0;
  color: #666666;
  margin-right: 6px;
}

/* --- 关键修改4：组织成员名字超出省略 --- */
.org-names {
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.con2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.content2 {
  height: 154px;
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: #666666;
  font-size: 17px;
}

.content2>img {
  width: 100%;
  height: 103px;
}

.con3 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.content3 {
  width: 100%;
  height: 36px;
  background-color: #f1f1f1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666666;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

body {
  background-color: #f8f8f8;
}

.active {
  border-bottom: 2px solid #bf1c29;
}

.top {
  width: 100%;
  height: 145px;
  background: url(@/assets/png/home/top.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.top .logo {
  height: 73px;
  display: flex;
  align-items: center;
}

.logo>.logo-left>img {
  width: 100%;
  height: 100%;
}

.logo-left {
  width: 50px;
  height: 66px;
}

.logo-right {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.top .tab {
  width: 24%;
  display: flex;
  justify-content: space-between;
}

.top .tab .box {
  cursor: pointer;
  height: 35px;
  font-family: MicrosoftYaHei;
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}

.e {
  width: 62%;
  height: 100%;
  display: flex;
  align-items: center;
}

.left2 {
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right2 {
  width: 85%;
  height: 60%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.foot {
  width: 100%;
  height: 161px;
  background-image: url(@/assets/png/home/bottom.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-left: 20%;
  box-sizing: border-box;
}
</style>